import Promise from 'promise-polyfill';

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}
export function populate( endpoint, headers ){

  return new Promise( function(resolve, reject){

    let xhttp = new XMLHttpRequest();
    var base_url = window.location.origin;

    if(base_url.includes('localhost') || base_url.includes('8080')){
        base_url = 'http://nhs-orkney.staging.civiccomputing.com'
    }
    xhttp.open( 'GET', base_url + endpoint, true);

    xhttp.onload = function() {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        let response = JSON.parse(xhttp.responseText);
        resolve(response);
      }
      else {
        reject( Error( xhttp.statusText ) );
      }
    };

    // reject promises in case of network issues
    xhttp.onerror = function() {
      reject( Error ( 'There was a network error.' ) );
    };

    xhttp.send();

  });

}
